module.exports = __webpack_public_path__ + "static/img/scene_pic4.58ea34c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/scene_pic4.png
// module id = MTL1
// module chunks = 1